import Smooch from 'gladlyinc';

export default function configureProvider(providerId) {
  const body = document.getElementsByTagName('body')[0];
  const smoochDiv = document.createElement('div');
  smoochDiv.setAttribute('id', 'gladlyChat_smooch_container');
  smoochDiv.setAttribute('style', 'display: none;');
  body.appendChild(smoochDiv);

  Smooch.render(smoochDiv);
  return Smooch.init({ appId: providerId, embedded: true });
}
